import { Users, Sparkles, LayoutGrid, ConciergeBell } from "lucide-react";
import { IMAGES } from "../data";
import { Reveal } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";

const CARDS = [
  { icon: Users, title: "Spacious Venue", text: "Comfortable space for weddings and celebrations.", testid: "marriage-card-spacious" },
  { icon: Sparkles, title: "Elegant Ambience", text: "A sophisticated setting for memorable occasions.", testid: "marriage-card-ambience" },
  { icon: LayoutGrid, title: "Flexible Setup", text: "Suitable for different event arrangements and celebrations.", testid: "marriage-card-flexible" },
  { icon: ConciergeBell, title: "Convenient Facilities", text: "Designed to make event planning easier.", testid: "marriage-card-facilities" },
];

const FIELDS = [
  { name: "name", label: "Name", type: "text", required: true, placeholder: "Your full name", testid: "marriage-form-name" },
  { name: "phone", label: "Phone Number", type: "tel", required: true, placeholder: "10-digit mobile number", testid: "marriage-form-phone" },
  {
    name: "event_type",
    label: "Event Type",
    type: "select",
    required: true,
    options: ["Wedding", "Reception", "Engagement", "Birthday Party", "Corporate Event", "Other Celebration"],
    testid: "marriage-form-event-type",
  },
  { name: "event_date", label: "Event Date", type: "date", required: true, testid: "marriage-form-event-date" },
  { name: "guests", label: "Number of Guests", type: "number", required: true, placeholder: "e.g. 300", testid: "marriage-form-guests" },
  { name: "message", label: "Message", type: "textarea", placeholder: "Tell us about your celebration...", testid: "marriage-form-message" },
];

export const MarriageHall = () => (
  <section id="marriage-hall" data-testid="marriage-hall-section" className="bg-navy py-16 sm:py-20 lg:py-28">
    <div className="section-wrap">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="eyebrow">Marriage Hall &amp; Banquet</p>
        <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-cream sm:text-4xl lg:text-5xl">
          Celebrate Your Special Moments
        </h2>
        <p className="mt-4 text-base text-cream/70 sm:text-lg">
          A beautiful venue for weddings, receptions and unforgettable celebrations.
        </p>
      </Reveal>

      <Reveal delay={150} className="mt-12">
        <div className="border border-gold/30 p-2.5 sm:p-3">
          <img
            src={IMAGES.marriageHall}
            alt="Grand marriage hall at Kasdol Hotel set up for a wedding celebration"
            loading="lazy"
            className="h-72 w-full object-cover sm:h-96 lg:h-[30rem]"
          />
        </div>
      </Reveal>

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 100}>
            <div
              data-testid={c.testid}
              className="h-full rounded-md border border-gold/15 bg-navy-dark p-6 transition-colors duration-300 hover:border-gold/40"
            >
              <c.icon className="h-7 w-7 text-gold" />
              <h3 className="mt-4 font-serif text-lg font-semibold text-cream">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/65">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-10 text-center">
        <a href="#marriage-enquiry" data-testid="marriage-book-cta" className="btn-gold">
          Book Marriage Hall
        </a>
      </Reveal>

      <Reveal delay={100}>
        <div id="marriage-enquiry" className="mx-auto mt-14 max-w-3xl scroll-mt-28 rounded-md bg-ivory p-6 shadow-2xl sm:p-10">
          <h3 className="font-serif text-2xl font-semibold text-navy sm:text-3xl">Marriage Hall Enquiry</h3>
          <p className="mt-2 text-sm text-ink/60">
            Share your event details and our team will get back to you shortly.
          </p>
          <div className="mt-7">
            <EnquiryForm
              formTestId="marriage-enquiry-form"
              submitTestId="marriage-form-submit"
              fields={FIELDS}
              submitLabel="Send Hall Enquiry"
              service="marriage-hall"
              successTitle="Hall Enquiry Received"
            />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
